import { render, staticRenderFns } from "./AccountView.vue?vue&type=template&id=719d8374&scoped=true"
import script from "./AccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AccountView.vue?vue&type=style&index=0&id=719d8374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719d8374",
  null
  
)

export default component.exports